<template>
  <div>
    <div class="top">
      <el-row>
        <el-col>
          <span style="margin-left:10px;margin-right:5px">老人姓名:</span>
          <el-input v-model="filter.oldName" placeholder="老人姓名" clearable style="width:150px" size="small" />
          <span style="margin-left:20px;margin-right:5px">发生时间:</span>
          <el-date-picker
            v-model="filter.time"
            clearable
            type="date"
            size="small"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
          <el-button style="margin-left:20px" type="primary" size="small" @click="queryList">查询</el-button>
        </el-col>
      </el-row>
    </div>

    <el-table
      :data="tableData"
      style="width: 100%;margin-top:10px"
      :header-cell-style="headerStyle"
      v-loading="loading"
    >
      <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
      <el-table-column prop="serviceDate" label="时间" align="center"></el-table-column>
      <el-table-column prop="oldName" label="老人姓名" align="center"></el-table-column>
      <el-table-column prop="feeTypeName" label="费用类型" align="center"></el-table-column>
      <el-table-column prop="feeItemName" label="项目名称" align="center"></el-table-column>
      <el-table-column label="项目费用（元）" align="center">
        <template slot-scope="scope">
          {{ scope.row.amount != null ? (scope.row.amount / 100).toFixed(2) : '--' }}
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="mini">
            {{ scope.row.status === 1 ? '有效' : '已取消' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" align="center"></el-table-column>
    </el-table>

    <el-row>
      <el-pagination
        style="text-align: center;margin-top:10px"
        background
        layout="total, prev, pager, next, jumper"
        @current-change="changePage"
        :current-page="pageNum"
        :page-size="pageSize"
        :total="total"
      ></el-pagination>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      filter: {
        oldName: "",
        time: ""
      },
      tableData: [],
      loading: false,
      pageNum: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    headerStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #F2F2F2;";
      }
    },
    queryList() {
      this.loading = true;
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        oldName: this.filter.oldName,
        serviceDate: this.filter.time
      };
      this.$postJson("fmc/perUseFee/queryListWithPage", params).then(
        (res) => {
          let data = res.result || res;
          this.tableData = data.list || [];
          this.total = Number(data.total || 0);
          this.loading = false;
        },
        () => { this.loading = false; }
      );
    },
    changePage(val) {
      this.pageNum = val;
      this.queryList();
    }
  },
  mounted() {
    this.queryList();
  }
};
</script>
<style lang="scss" scoped>
.top {
  background: #f2f2f2;
  padding: 6px;
}
</style>